import cx from 'classnames';
import { CSSProperties } from 'react';

export type TRioLoaderSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type TRioLoaderType = 'oval' | 'dots';

export interface IRioLoaderProps {
  size?: TRioLoaderSize;
  type?: TRioLoaderType;
  className?: string;
  style?: CSSProperties;
  label?: string;
}

// Inline loader; color inherits via currentColor so it themes with its context.
export function RioLoader({ size = 'md', type = 'oval', className, style, label = 'Loading' }: IRioLoaderProps) {
  return (
    <span
      role="status"
      aria-label={label}
      style={style}
      className={cx('rio-loader', `rio-loader--${size}`, `rio-loader--${type}`, className)}
    >
      {type === 'oval' ? (
        <svg className="rio-loader__oval" viewBox="0 0 50 50" aria-hidden="true">
          <circle className="rio-loader__oval-track" cx="25" cy="25" r="20" />
          <circle className="rio-loader__oval-arc" cx="25" cy="25" r="20" />
        </svg>
      ) : (
        <>
          <span className="rio-loader__dot" />
          <span className="rio-loader__dot" />
          <span className="rio-loader__dot" />
        </>
      )}
    </span>
  );
}
